import { push } from '@r1-frontend/analytics/campaignLayer';

import { toggleIsShowSpecOffer } from '~/src/features/payments-abn/store/actionCreators';
import { specialOfferAnalytics } from '~/src/features/specialOffersContainer/analytics';
import { selectNewOrViewedOffers } from '~/src/features/specialOffersContainer/store/selectors';
import { TAppThunkDispatch, TGetState } from '~/src/store';

const showSpecOffer = () => (dispatch: TAppThunkDispatch, getState: TGetState) => {
    const state = getState();
    const { stopper } = selectNewOrViewedOffers(state);

    if (!stopper) {
        return;
    }

    specialOfferAnalytics.view(stopper);
    push({ id: stopper.id, type: 'spec-offer', actionType: 'view' });

    dispatch(toggleIsShowSpecOffer(true));
};

export default showSpecOffer;
